import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const Withdraw = lazy(() => import('./withdraw'));

export default {
  path: 'withdraw',
  element: <ProtectedRoute title="余额提现" component={<Withdraw />} />,
};
